import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Home2 from "../views/Home2.vue";
import Home3 from "../views/Home3.vue";
//import Login from "../views/Login.vue";
//import Register from "../views/Register.vue";
import Dashboard from "../views/Dashboard.vue";
import Projects from "../views/Projects.vue";
import Clients from "../views/Clients.vue";
import Settings from "../views/Settings.vue";
import About from "../views/About.vue";
import NotFound from "../views/404.vue";
import store from "../store/store";

Vue.use(VueRouter);

const reqAuth = { requiresAuth: true, transitionName: 'slide' };

const routes = [
  //{ path: '/', name: "home", redirect: "dashboard" },
  //{ path: '/', name: "home", component: Home },
  { path: '/', name: "home", component: Home3 },
  //{ path: '/login', name: "login", component: Login },
  //{ path: '/register', name: "register", component: Register },
  { path: '/dashboard', name: "dashboard", component: Dashboard, meta: reqAuth },
  { path: '/projects', name: "projects", component: Projects, meta: reqAuth },
  { path: '/clients', name: "clients", component: Clients, meta: reqAuth },
  { path: '/settings', name: "settings", component: Settings, meta: reqAuth },
  { path: '/about', name: "about", component: About, meta: reqAuth },
  { path: '*', redirect: "dashboard" } //,

  //{ path: '/ignore', component: () => import './pages/Home.vue' }   // tbd. Why doesn't this compile?
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


router.beforeEach(async (to, from, next) => {

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const loggedIn = store.getters.isLoggedIn;

  console.log(`router entering page: ${to.path}`, "requiresAuth", requiresAuth, "-> loggedIn: " + loggedIn);

  // if we require a login and we are not logged in then redirect to /loginfb
  if (requiresAuth && !loggedIn) {

    //next('/login');

    // if (to.path === '/') {
    //   next('/login');
    // } else {
    //   next(`/login?final=${to.path}`);
    // }
  } else {

    // sneaky - if /settings then prepare the settings data
    if (to.path == "/settings") {
      //debugger;
      store.dispatch("createUserInfoClone");
    }

    next();   // carry on
  }

});

export default router;
